exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.modal-title--primary[data-v-f5f61ce2] {\n  background: #1b0b37;\n  color: white;\n  border: 1px solid rgba(242, 242, 242, 0.5);\n}\n.modal-title--icon[data-v-f5f61ce2] {\n  max-width: 45px;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/components/modal/styles.scss"],"names":[],"mappings":";AACE;EACE,oBAA2B;EAC3B,aAAY;EACZ,2CAA0C;CAC3C;AACD;EACE,gBAAc;CACf","file":"styles.scss","sourcesContent":[".modal-title {\n  &--primary {\n    background: rgb(27, 11, 55);\n    color: white;\n    border: 1px solid rgba(242, 242, 242, 0.5);\n  }\n  &--icon{\n    max-width:45px;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f5f61ce2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/modal/styles.scss
// module id = xBjJ
// module chunks = 0